<div
  class="grid grid-flow-col gap-1 items-center justify-start px-3 py-1 rounded-[4px] box-border border-[1px]"
  [ngClass]="{
    'border-neutrals-300 bg-neutrals-0': !closingProbability,
    'border-[#81B87A] bg-[#EAFFE7]': closingProbability,
  }"
>
  <ui-icon
    *ngIf="closingProbability"
    name="star-filled"
    m-size="20"
    size="20"
    name="priority-very-high"
    view-box="0 0 20 20"
  />
  <ui-paragraph type="p12" mobile-type="p12" text-color="neutrals-900">
    {{ getPriorityText(closingProbability) }} {{ text }}
  </ui-paragraph>
</div>
